import { render, staticRenderFns } from "./CreateClient.vue?vue&type=template&id=3912a282&scoped=true"
import script from "./CreateClient.vue?vue&type=script&lang=ts"
export * from "./CreateClient.vue?vue&type=script&lang=ts"
import style0 from "./CreateClient.vue?vue&type=style&index=0&id=3912a282&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3912a282",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3912a282')) {
      api.createRecord('3912a282', component.options)
    } else {
      api.reload('3912a282', component.options)
    }
    module.hot.accept("./CreateClient.vue?vue&type=template&id=3912a282&scoped=true", function () {
      api.rerender('3912a282', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/companyProjects/ClientTabsComponents/CreateClient.vue"
export default component.exports